var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8791 4.51313C18.0393 4.75573 18.0125 5.0854 17.799 5.29897L10.1387 12.9593C10.0601 13.0378 9.96209 13.094 9.85468 13.1221L6.66431 13.9554C6.56025 13.9826 6.45299 13.982 6.35222 13.9563C6.24507 13.9291 6.14527 13.8735 6.06442 13.7926C5.90752 13.6358 5.84557 13.4074 5.90165 13.1927L6.73498 10.0023C6.75954 9.90833 6.80562 9.8155 6.86936 9.74267L14.5581 2.05806C14.6253 1.99076 14.7064 1.94038 14.7947 1.90969C14.8601 1.88693 14.9294 1.875 15 1.875C15.1658 1.875 15.3248 1.94085 15.4419 2.05806L17.799 4.41508C17.8295 4.44559 17.8562 4.47847 17.8791 4.51313ZM16.4732 4.85703L15 3.38388L7.90154 10.4823L7.38072 12.4763L9.37468 11.9555L16.4732 4.85703Z",
    fill: "#201E2A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3678 14.3007C16.5957 12.3527 16.6682 10.3911 16.5852 8.43445C16.5813 8.34078 16.6166 8.2496 16.6828 8.1833L17.5022 7.36386C17.603 7.26311 17.7752 7.32706 17.7846 7.46923C17.9387 9.79395 17.8802 12.1292 17.6093 14.4459C17.4122 16.1314 16.0586 17.4522 14.3819 17.6396C11.4931 17.9624 8.5069 17.9624 5.61813 17.6396C3.94141 17.4522 2.5878 16.1314 2.39068 14.4459C2.04523 11.4924 2.04523 8.50853 2.39068 5.55497C2.5878 3.86953 3.94141 2.54869 5.61813 2.36129C7.80959 2.11636 10.0571 2.05724 12.2755 2.18391C12.4185 2.19208 12.4837 2.36509 12.3824 2.46636L11.5553 3.29349C11.4897 3.35906 11.3998 3.39429 11.3071 3.39116C9.45174 3.32858 7.58378 3.39938 5.75697 3.60356C4.64855 3.72744 3.76064 4.60211 3.63221 5.70018C3.29805 8.55728 3.29805 11.4436 3.63221 14.3007C3.76064 15.3988 4.64855 16.2734 5.75697 16.3974C8.55349 16.7099 11.4465 16.7099 14.243 16.3974C15.3515 16.2734 16.2393 15.3988 16.3678 14.3007Z",
    fill: "#201E2A"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/icon_edit.f71220cba9448ffc9fa167b7ce744790.svg";
export { ForwardRef as ReactComponent };